import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { AutoMetricEventType } from "../core";
import { useAutoMetricContext } from "./hooks/useAutoMetricContext";
import { AutoMetricContext } from "./context";
export var AutoMetricGoal = function AutoMetricGoal(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? AutoMetricEventType.CLICK : _ref$type,
    goal = _ref.goal;
  var context = useAutoMetricContext();
  return /*#__PURE__*/React.createElement(AutoMetricContext.Provider, {
    value: useMemo(function () {
      return _objectSpread(_objectSpread({}, context), {}, {
        goals: _objectSpread(_objectSpread({}, context.goals), {}, _defineProperty({}, type, goal))
      });
    }, [context, type, goal])
  }, children);
};
AutoMetricGoal.propTypes = process.env.NODE_ENV !== "production" ? {
  goal: PropTypes.string,
  type: PropTypes.oneOf([AutoMetricEventType.CLICK, AutoMetricEventType.VIEW]),
  children: PropTypes.node
} : {};